import React from 'react';
import ReactDOM, { Container } from 'react-dom/client';
import '@slai/ui/styles.css';
import App from './App';
import './App.scss';
import { initializeTheme } from './hooks/useTheme';
import AppProviders from './providers/AppProviders';

initializeTheme();

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container as Container);
root.render(
    <AppProviders>
        <App />
    </AppProviders>
);
